<div class="height100p flex-col">
    <div class="flex-item-fill overflow-y-auto">
        <div #host></div>
    </div>

    @if (buttons != null) {
        <p-footer class="mt-4 mb-2 flex-item-fixed">
            @for (button of buttons; track button) {
                <button
                    pButton
                    [class]="'mr-1 ' + button.style"
                    [severity]="button.severity"
                    [icon]="button.icon"
                    [label]="button.caption"
                    (click)="click(button)">
                </button>
            }
        </p-footer>
    }
</div>
